import {reportToBugsnag} from '../../libs/shared/core/src/services/bugsnag/bugsnag';

export function getFilesFromDataTransfer(dataTransfer: DataTransfer): Array<File> {
  const files: Array<File> = [];

  /* eslint-disable no-continue */
  const {items} = dataTransfer;
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    if (item.kind !== 'file') {
      continue;
    }

    const file = item.getAsFile();
    if (!file) {
      continue;
    }

    files.push(file);
  }
  /* eslint-enable no-continue */

  return files;
}

export function logDataTransfer(dataTransfer: DataTransfer | null) {
  try {
    if (!dataTransfer) {
      // eslint-disable-next-line no-console
      console.log('Null DataTransfer');
      return;
    }

    // eslint-disable-next-line no-console
    console.log(getLogInfoFromDataTransfer(dataTransfer));
  } catch (err) {
    reportToBugsnag(err);
  }
}

function getLogInfoFromDataTransfer(dataTransfer: DataTransfer) {
  // Note: dataTransfer.types and/or dataTransfer.files may be undefined on Edge.
  return {
    strings: Array.from(dataTransfer.types || [])
      .filter((type) => type !== 'Files')
      .map((type) => ({
        type,
        data: dataTransfer.getData(type),
      })),
    files: Array.from(dataTransfer.files || []).map(({type, name, size}) => ({
      type,
      name,
      size,
    })),
  };
}
